import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchLiveUpdates = (args) => {
    return doDefaultFetch(
        `/site/api/live-updates/public` +
        `?cayenneExp=date="${args.date}"`,
        args
    );
};

const fetchLastLiveUpdate = (args) => doDefaultFetch(`/site/api/live-updates/public/last-live-update`, args);

export default {
    fetchLiveUpdates,
    fetchLastLiveUpdate,
};
